import React from "react";
import { updateObject } from "../../shared/utility";
import FetchData from "../../shared/fetchData";
import Input from "../UI/Input/Input";
import Button from "../UI/Button/Button";
import { Collapse } from "@material-ui/core";
import ContentForm from "../UI/ContentForm/ContentForm";
import Select from "../UI/Select/Select";
// import "../UnitFranchiseKioskForm.css";

const UnitFranchiseKioskForm = (props) => {

    const [edit, setEdit] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [id, setId] = React.useState('')
    const [kiosks, setKiosks] = React.useState([])
    const [units, setUnits] = React.useState([])
    const [kiosk, setKiosk] = React.useState('')
    const [unit, setUnit] = React.useState('')
    const [loading, setLoading] = React.useState(false)


    React.useEffect(() => {
        var raw = JSON.stringify({ "pl": "1000", "pn": "1", "version": "mtpx001" })
        var url = 'management/api/v1/kiosks/getKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (props.edit == true) {
                    const ksk = result.kiosks.filter(k => k.id == props.unitFranchiseKiosk.kioskId);
                    if (!!ksk && ksk.length > 0) {
                        setKiosk({
                            label: ksk[0].description,
                            value: ksk[0].id,
                        });
                    }
                }
                setKiosks(result.kiosks)
            })
            .catch(error => console.log(''))
        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (props.edit == true) {
                    const unt = result.units.filter(k => k.id == props.unitFranchiseKiosk.unitId);
                    if (!!unt && unt.length > 0) {
                        setUnit({
                            label: unt[0].unitName,
                            value: unt[0].id,
                        });
                    }
                }
                setUnits(result.units);
            })
            .catch(error => setLoading(false))
        if (props.edit == true) {

            setEdit(true)
            setId(props.unitFranchiseKiosk.id)
        }
    }, [props.unitFranchiseKiosk])

    const insertUnitFranchiseKioskForm = (event) => {
        let valid = true;
        if (unit == null || kiosk == null || unit == '' || kiosk == '') {
            valid = false;
        }
        if (valid) {
            const info = {
                "unitFranchiseKiosk": {
                    "id": edit ? id : '',
                    "unitId": unit?.value,
                    "kioskId": kiosk?.value,
                },
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = !edit ? 'management/api/v1/franchises/insertUnitFranchiseKiosk' : 'management/api/v1/franchises/updateUnitFranchiseKiosk';
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == "0") {
                        props.toggleNewUnitFranchiseKioskFormFormAndReload(event, false)
                    }
                })
        } else {
            setRerender(!rerender);
        }
    }
    const changeUnit = (selectedOption) => {
        setUnit(selectedOption);
    }

    const changeKiosk = (selectedOption) => {
        setKiosk(selectedOption);
    }
    let unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }

    let kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }

    return (
        <>
            <div className='row justify-content-center'>
                <div className='ksk-cntnr'>
                    <ContentForm headetText='اطلاعات فرانچایز'>
                        <div className='ksk-frm'>
                            <div className="row w-100 mt-4">
                                <Select
                                    name="form-field-name"
                                    value={unit}
                                    placeholder="حساب"
                                    options={unitList}
                                    onChange={changeUnit}
                                    col="6 mt-2"
                                />
                                <Select
                                    name="form-field-name"
                                    value={kiosk}
                                    placeholder="لاکر"
                                    options={kioskList}
                                    onChange={changeKiosk}
                                    col="6 mt-2"
                                />
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row justify-content-center w-100 mt-3'>
                                <div className='col-6 text-center'>
                                    <Button btnType="Success" clicked={insertUnitFranchiseKioskForm}>ثبت</Button>
                                </div>
                                <div className='col-6 text-center'>
                                    <Button btnType="General" clicked={(event) => props.toggleNewUnitFranchiseKioskForm(event, false)}>برگشت</Button>
                                </div>
                            </div>
                        </div>
                    </ContentForm>
                </div>
            </div>
        </>
    )
}

export default UnitFranchiseKioskForm;